/*
 * @Author: huangzeshen
 * @Date: 2024-03-28 14:02:02
 * @LastEditors: huangzeshen
 * @LastEditTime: 2024-04-12 16:41:52
 * @FilePath: /waton-mobile/src/i18n/index.js
 * @Description: 
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import zhCN from './locals/zh-CN';
import enUS from './locals/en-US';
import zhHK from './locals/zh-HK';

import { getLanguage } from '@/utils/public'


i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: getLanguage() || 'zh',
    lng: getLanguage(),
    debug: true,
    resources: {
      zh: {
        translation: zhCN,
      },
      en: {
        translation: enUS,
      },
      'zh-HK': {
        translation: zhHK,
      }
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

export default i18n;